import React from "react";

const normalizarCategoriaLocal = (valor) => {
  return String(valor || "")
    .trim()
    .replace(/\s+/g, " ")
    .toUpperCase();
};

function AdminProductoForm({
  idSeleccionado,
  handleSubmit,
  nombre,
  setNombre,
  turno,
  setTurno,
  seccion,
  setSeccion,
  descripcion,
  setDescripcion,
  precio,
  setPrecio,
  setImagenArchivo,
  categoriasExistentes,
  mostrarSugerencias,
  setMostrarSugerencias,
  opcionesSinCosto,
  nombreOpcionSinCosto,
  setNombreOpcionSinCosto,
  tipoOpcionSinCosto,
  setTipoOpcionSinCosto,
  requeridaOpcionSinCosto,
  setRequeridaOpcionSinCosto,
  valoresOpcionSinCosto,
  setValoresOpcionSinCosto,
  handleAgregarOpcionSinCosto,
  handleEliminarOpcionSinCosto,
  extrasLista,
  nombreExtra,
  setNombreExtra,
  precioExtra,
  setPrecioExtra,
  handleAgregarExtraALista,
  handleEliminarExtraDeLista,
  cargando,

  // Nuevos props para orden de categorías
  categoriaConfiguradaActual = null,
  categoriaNuevaDetectada = false,
  ordenCategoriaNueva = "",
  setOrdenCategoriaNueva = () => {},
  ordenMaximoCategoriaNueva = 1,
  categoriaConOrdenOcupadoProducto = null,
  categoriasOrdenadasDelTurno = [],
}) {
  const seccionNormalizada = normalizarCategoriaLocal(seccion);

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        backgroundColor: "#fff",
        padding: "24px",
        borderRadius: "16px",
        border: "1px solid #e2e2e2",
      }}
    >
      <h3
        style={{
          margin: "0 0 20px 0",
          fontSize: "18px",
          fontWeight: "700",
        }}
      >
        {idSeleccionado ? "Modificar Producto" : "Nuevo Producto"}
      </h3>

      <div style={{ marginBottom: "16px" }}>
        <label style={labelStyle}>Nombre</label>

        <input
          type="text"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          style={inputStyle}
        />
      </div>

      <div
        style={{
          display: "flex",
          gap: "12px",
          marginBottom: "16px",
        }}
      >
        <div style={{ flex: 1 }}>
          <label style={labelStyle}>Turno</label>

          <select
            value={turno}
            onChange={(e) => setTurno(e.target.value)}
            style={inputStyle}
          >
            <option value="matutino">🌅 Matutino</option>
            <option value="vespertino">🌌 Vespertino</option>
            <option value="ambos">☕ Ambos</option>
          </select>
        </div>

        <div
          style={{
            flex: 1,
            position: "relative",
          }}
        >
          <label style={labelStyle}>Categoría</label>

          <input
            type="text"
            value={seccion}
            onFocus={() => setMostrarSugerencias(true)}
            onBlur={() => {
              setTimeout(() => setMostrarSugerencias(false), 220);
              setSeccion(normalizarCategoriaLocal(seccion));
            }}
            onChange={(e) => setSeccion(e.target.value.toUpperCase())}
            placeholder="Ej. PARA COMENZAR"
            style={inputStyle}
          />

          {mostrarSugerencias && (
            <div
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                borderRadius: "8px",
                zIndex: 10,
                maxHeight: "150px",
                overflowY: "auto",
                marginTop: "4px",
              }}
            >
              {categoriasExistentes
                .filter((cat) =>
                  normalizarCategoriaLocal(cat).includes(seccionNormalizada),
                )
                .map((cat, index) => (
                  <div
                    key={index}
                    onMouseDown={() => setSeccion(cat)}
                    style={{
                      padding: "10px",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                  >
                    📁 {cat}
                  </div>
                ))}
            </div>
          )}
        </div>
      </div>

      {seccionNormalizada && categoriaConfiguradaActual && (
        <div
          style={{
            backgroundColor: "#e8f5e9",
            border: "1px solid #c8e6c9",
            color: "#1b5e20",
            borderRadius: "12px",
            padding: "12px",
            marginBottom: "16px",
            fontSize: "13px",
            fontWeight: "800",
            lineHeight: "1.5",
          }}
        >
          ✅ Categoría configurada:{" "}
          <strong>{categoriaConfiguradaActual.nombre}</strong>
          <br />
          Orden actual en el menú:{" "}
          <strong>{categoriaConfiguradaActual.orden}</strong>
        </div>
      )}

      {seccionNormalizada && categoriaNuevaDetectada && !idSeleccionado && (
        <div
          style={{
            backgroundColor: "#fff8e1",
            border: "1px solid #ffe0a3",
            borderRadius: "14px",
            padding: "14px",
            marginBottom: "16px",
          }}
        >
          <h4
            style={{
              margin: "0 0 8px 0",
              fontSize: "15px",
              fontWeight: "900",
              color: "#7a4b00",
            }}
          >
            🗂️ Nueva categoría detectada
          </h4>

          <p
            style={{
              margin: "0 0 12px 0",
              fontSize: "13px",
              color: "#7a4b00",
              lineHeight: "1.5",
              fontWeight: "700",
            }}
          >
            La categoría <strong>{seccionNormalizada}</strong> todavía no tiene
            orden configurado. Indica en qué posición debe aparecer en la
            tienda.
          </p>

          {categoriasOrdenadasDelTurno.length > 0 && (
            <div
              style={{
                backgroundColor: "#fff",
                border: "1px solid #f1ddab",
                borderRadius: "12px",
                padding: "10px",
                marginBottom: "12px",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "900",
                  color: "#7a4b00",
                  marginBottom: "6px",
                }}
              >
                Orden actual:
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "6px",
                  flexWrap: "wrap",
                }}
              >
                {categoriasOrdenadasDelTurno.map((categoria) => (
                  <span
                    key={categoria.id}
                    style={{
                      backgroundColor: "#f7f7f7",
                      border: "1px solid #eee",
                      borderRadius: "999px",
                      padding: "5px 8px",
                      fontSize: "11px",
                      fontWeight: "800",
                      color: "#444",
                    }}
                  >
                    {categoria.orden}. {categoria.nombre}
                  </span>
                ))}
              </div>
            </div>
          )}

          <label style={labelStyle}>Orden de esta nueva categoría</label>

          <input
            type="number"
            min="1"
            max={ordenMaximoCategoriaNueva}
            value={ordenCategoriaNueva}
            onChange={(e) => setOrdenCategoriaNueva(e.target.value)}
            placeholder={`Máximo permitido: ${ordenMaximoCategoriaNueva}`}
            style={{
              ...inputStyle,
              marginBottom: "10px",
            }}
          />

          <div
            style={{
              fontSize: "12px",
              color: "#7a4b00",
              lineHeight: "1.5",
              fontWeight: "700",
            }}
          >
            Máximo permitido: <strong>{ordenMaximoCategoriaNueva}</strong>. Si
            eliges un número ocupado, el sistema podrá insertar la categoría ahí
            y recorrer las siguientes.
          </div>

          {Number(ordenCategoriaNueva) > Number(ordenMaximoCategoriaNueva) && (
            <div
              style={{
                backgroundColor: "#fff4f4",
                border: "1px solid #ffd0d0",
                color: "#8b0000",
                borderRadius: "10px",
                padding: "10px",
                marginTop: "10px",
                fontSize: "13px",
                fontWeight: "800",
              }}
            >
              ⚠️ No puedes brincar números. El máximo permitido es{" "}
              {ordenMaximoCategoriaNueva}.
            </div>
          )}

          {categoriaConOrdenOcupadoProducto && (
            <div
              style={{
                backgroundColor: "#fff4f4",
                border: "1px solid #ffd0d0",
                color: "#8b0000",
                borderRadius: "10px",
                padding: "10px",
                marginTop: "10px",
                fontSize: "13px",
                fontWeight: "800",
              }}
            >
              ⚠️ El orden {ordenCategoriaNueva} ya está ocupado por{" "}
              {categoriaConOrdenOcupadoProducto.nombre}. Si continúas, la nueva
              categoría se insertará en esa posición y las siguientes se
              recorrerán.
            </div>
          )}
        </div>
      )}

      <div style={{ marginBottom: "16px" }}>
        <label style={labelStyle}>Descripción</label>

        <textarea
          value={descripcion}
          onChange={(e) => setDescripcion(e.target.value)}
          rows="2"
          style={{
            ...inputStyle,
            resize: "vertical",
          }}
        />
      </div>

      <div style={{ marginBottom: "16px" }}>
        <label style={labelStyle}>Precio</label>

        <input
          type="number"
          value={precio}
          onChange={(e) => setPrecio(e.target.value)}
          style={inputStyle}
        />
      </div>

      <div style={{ marginBottom: "24px" }}>
        <input
          id="input-foto"
          type="file"
          accept="image/*"
          onChange={(e) => setImagenArchivo(e.target.files[0])}
        />
      </div>

      <div style={boxStyle}>
        <h4 style={boxTitleStyle}>Extras con costo</h4>

        <p style={helpTextStyle}>
          Estos modificadores aumentan el precio del producto.
        </p>

        <div
          style={{
            display: "flex",
            gap: "10px",
            marginBottom: "12px",
          }}
        >
          <input
            type="text"
            value={nombreExtra}
            onChange={(e) => setNombreExtra(e.target.value)}
            placeholder="Extra"
            style={{
              flex: 2,
              padding: "8px",
            }}
          />

          <input
            type="number"
            value={precioExtra}
            onChange={(e) => setPrecioExtra(e.target.value)}
            placeholder="+$"
            style={{
              flex: 1,
              padding: "8px",
            }}
          />

          <button type="button" onClick={handleAgregarExtraALista}>
            +
          </button>
        </div>

        {extrasLista.map((ext, idx) => (
          <div key={idx} style={itemListStyle}>
            <span>
              {ext.nombre} (+${ext.precio})
            </span>

            <button
              type="button"
              onClick={() => handleEliminarExtraDeLista(idx)}
            >
              ✕
            </button>
          </div>
        ))}
      </div>

      <div style={boxStyle}>
        <h4 style={boxTitleStyle}>Opciones sin costo</h4>

        <p style={helpTextStyle}>
          Úsalas para término de carne, guarnición o quitar ingredientes. No
          modifican el precio.
        </p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: "10px",
            marginBottom: "12px",
          }}
        >
          <input
            type="text"
            value={nombreOpcionSinCosto}
            onChange={(e) => setNombreOpcionSinCosto(e.target.value)}
            placeholder="Nombre de la opción. Ej. Término, Guarnición, Quitar ingredientes"
            style={inputStyle}
          />

          <select
            value={tipoOpcionSinCosto}
            onChange={(e) => setTipoOpcionSinCosto(e.target.value)}
            style={inputStyle}
          >
            <option value="unica">Selección única</option>
            <option value="multiple">Selección múltiple</option>
          </select>

          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "13px",
              fontWeight: "700",
            }}
          >
            <input
              type="checkbox"
              checked={requeridaOpcionSinCosto}
              onChange={(e) => setRequeridaOpcionSinCosto(e.target.checked)}
            />
            Requerir selección antes de agregar al carrito
          </label>

          <textarea
            value={valoresOpcionSinCosto}
            onChange={(e) => setValoresOpcionSinCosto(e.target.value)}
            placeholder="Opciones separadas por coma. Ej. Rojo, Medio, 3/4, Bien cocido"
            rows={2}
            style={{
              ...inputStyle,
              resize: "vertical",
            }}
          />

          <button
            type="button"
            onClick={handleAgregarOpcionSinCosto}
            style={{
              backgroundColor: "#111",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              padding: "10px",
              fontWeight: "800",
              cursor: "pointer",
            }}
          >
            Agregar opción sin costo
          </button>
        </div>

        {opcionesSinCosto.map((opcion, idx) => (
          <div key={idx} style={itemListStyle}>
            <div>
              <strong>{opcion.nombre}</strong>
              <div
                style={{
                  fontSize: "12px",
                  color: "#666",
                  marginTop: "3px",
                }}
              >
                {opcion.tipo === "multiple"
                  ? "Selección múltiple"
                  : "Selección única"}{" "}
                · {opcion.requerido ? "Requerida" : "Opcional"}
              </div>

              <div
                style={{
                  fontSize: "12px",
                  color: "#444",
                  marginTop: "3px",
                }}
              >
                {opcion.opciones.join(", ")}
              </div>
            </div>

            <button
              type="button"
              onClick={() => handleEliminarOpcionSinCosto(idx)}
            >
              ✕
            </button>
          </div>
        ))}
      </div>

      <button
        type="submit"
        disabled={cargando}
        style={{
          width: "100%",
          backgroundColor: "#111",
          color: "#fff",
          border: "none",
          borderRadius: "10px",
          padding: "14px",
          fontWeight: "800",
          cursor: "pointer",
        }}
      >
        {cargando ? "Guardando..." : idSeleccionado ? "Actualizar" : "Guardar"}
      </button>
    </form>
  );
}

const labelStyle = {
  display: "block",
  fontSize: "14px",
  fontWeight: "600",
  marginBottom: "6px",
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  boxSizing: "border-box",
};

const boxStyle = {
  marginBottom: "24px",
  padding: "16px",
  backgroundColor: "#f9f9f9",
  borderRadius: "12px",
  border: "1px solid #e2e2e2",
};

const boxTitleStyle = {
  margin: "0 0 6px 0",
  fontSize: "15px",
  fontWeight: "700",
};

const helpTextStyle = {
  margin: "0 0 12px 0",
  fontSize: "12px",
  color: "#666",
  lineHeight: "1.4",
};

const itemListStyle = {
  display: "flex",
  justifyContent: "space-between",
  gap: "10px",
  padding: "8px 10px",
  backgroundColor: "#fff",
  borderRadius: "6px",
  marginBottom: "6px",
  fontSize: "13px",
};

export default AdminProductoForm;
